import React, { useRef } from 'react';
import Icon from '../AppIcon';

const FileUpload = ({ 
  onUpload, 
  accept = "*", 
  multiple = false, 
  maxSize = 5 * 1024 * 1024, // 5MB default
  className = "",
  children 
}) => {
  const fileInputRef = useRef(null);

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    
    // Filter files by size
    const validFiles = files.filter(file => {
      if (file.size > maxSize) {
        alert(`File ${file.name} is too large. Maximum size is ${(maxSize / 1024 / 1024).toFixed(1)}MB`);
        return false;
      }
      return true;
    });

    if (validFiles.length > 0) {
      onUpload(validFiles);
    }

    // Reset input
    e.target.value = '';
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const files = Array.from(e.dataTransfer.files);
    
    // Filter files by accept type if specified
    const validFiles = files.filter(file => {
      if (accept !== "*" && !accept.split(',').some(type => 
        file.type.includes(type.replace('*', '')) || file.name.endsWith(type.replace('*', ''))
      )) {
        return false;
      }
      
      if (file.size > maxSize) {
        alert(`File ${file.name} is too large. Maximum size is ${(maxSize / 1024 / 1024).toFixed(1)}MB`);
        return false;
      }
      return true;
    });

    if (validFiles.length > 0) {
      onUpload(validFiles);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div 
      className={`relative ${className}`}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
    >
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={handleFileSelect}
        className="hidden"
      />
      
      {children ? (
        <div onClick={() => fileInputRef.current?.click()}>
          {children}
        </div>
      ) : (
        <div 
          onClick={() => fileInputRef.current?.click()}
          className="cursor-pointer flex flex-col items-center justify-center p-6"
        >
          <Icon name="Upload" size={32} className="text-gray-400 mb-2" />
          <p className="text-sm text-gray-600 text-center">
            Click to upload or drag and drop files here
          </p>
          <p className="text-xs text-gray-500 mt-1">
            Max file size: {(maxSize / 1024 / 1024).toFixed(1)}MB
          </p>
        </div>
      )}
    </div>
  );
};

export default FileUpload;
